<template>
	<div>
		<p>
			The gateway can send authentication to your Signal mobile and deskop app.
		</p>
	</div>
</template>

<script>
	export default {
		name: "SignalInstructions"
	}
</script>
